<div class="city-dialog">
  <app-search-cities-input [(ngModel)]="selectedCity" mode="single" [loading]="loading">
    {{ 'components.citySwitcher.labels.inputText' | translate }}
  </app-search-cities-input>

  <div class="footer">
    <button tuiButton type="button" class="footer__button" [disabled]="loading" (click)="onClickSaveButton()">
      {{ 'common.buttons.save' | translate }}
    </button>
  </div>
</div>
